import gql from 'graphql-tag'

const AllClaims = gql`
  query ClaimConnection($filter: ClaimFilter, $after: String, $before: String, $first: Int, $last: Int) {
    claimsConnection(filter: $filter, after: $after, before: $before, first: $first, last: $last) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          id
          crmState
          passengerTicket {
            id
            passengerFirstName
            passengerLastName
          }
          airline {
            countryName
            name
          }
          reason
          claimsPassengerTicketConnection {
            edges {
              cursor
            }
          }
        }
      }
    }
  }
`

export { AllClaims }



// WEBPACK FOOTER //
// ./src/queries/AllClaims.js